var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    this.$route.query.isApp == 1
      ? _c("div", [
          !_vm.isLoading && _vm.linkType !== 3
            ? _c("div", { staticClass: "contract-header" }, [
                _c("div", [
                  _c("i", {
                    staticClass: "iconfont icon-xiangyou",
                    class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.goBack.apply(null, arguments)
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          this.$route.query.isBanner == 0 && !_vm.isLoading
            ? _c("div", { staticClass: "contract-header" }, [
                _c("div", [
                  _c("i", {
                    staticClass: "iconfont icon-xiangyou",
                    class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.goBack.apply(null, arguments)
                      }
                    }
                  })
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "newBg" },
      [
        this.$route.query.isApp != 1
          ? _c("InCompleteSiteHead", { staticClass: "InCompleteSiteHead" })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "bg" }, [
          _c("div", { staticClass: "h5Title" }, [
            _c("div", { staticClass: "titleHeight" }),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("10000004")))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "titleTest" }, [
              _c("div", { staticClass: "titleTest-test" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("10000005")))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttonModule" }, [
              _c("div", { staticClass: "buttonModule-buttons" }, [
                _c(
                  "div",
                  {
                    class: _vm.changeApplication,
                    on: { click: _vm.goApplication }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.textVar) +
                        "\n                        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "share", on: { click: _vm.goShareUrl } },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("300342")) +
                        "\n                        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "timeModule" }, [
              _c(
                "div",
                { staticClass: "timeModule-main" },
                [
                  _c("christmasCountDown", {
                    attrs: { "end-time": _vm.resultObj.endTime, type: "2" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.resultObj.startTime && _vm.resultObj.endTime
                ? _c("div", { staticClass: "timeModule-time" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("300142")) +
                        ":    " +
                        _vm._s(_vm.formatTimestamp(_vm.resultObj.startTime)) +
                        " ~ " +
                        _vm._s(_vm.formatTimestamp(_vm.resultObj.endTime)) +
                        "\n                    "
                    )
                  ])
                : _c("div", { staticClass: "timeModule-time" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("300142")) +
                        ":     -- ~ --\n                    "
                    )
                  ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "leekBar" }, [
          _c("div", { staticClass: "leekBar-main" }, [
            _c("div", { staticStyle: { margin: "0 auto" } }, [
              _c("div", { staticClass: "leekBar-main-guys" }, [
                _c("div", { staticClass: "man" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("9000004")))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.mathGuys))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line" }),
                _vm._v(" "),
                _c("div", { staticClass: "money" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("9000005")))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.moneyPond))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "leekBar-main-pro" }, [
              _c(
                "div",
                { staticClass: "progressBar" },
                [
                  _c("transition", { attrs: { name: "progress-fade" } }, [
                    _c("div", { ref: "barRow", staticClass: "barRow" }, [
                      _vm.playGuys
                        ? _c(
                            "div",
                            {
                              ref: "progress",
                              staticClass: "rate-of-progress",
                              style: { height: _vm.progressWidth }
                            },
                            [
                              _c("div", {
                                ref: "mask",
                                staticClass: "progress-img",
                                style: {
                                  height: _vm.progressWidth,
                                  animationDuration: _vm.duration
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "progress-color" })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.playGuys
                        ? _c("div", { staticClass: "rate-of-progress" }, [
                            _c("div", { staticClass: "progress-img" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "progress-color" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "leveIcon" }, [
                        _c("img", {
                          staticClass: "blackIcon leveIcon-one",
                          attrs: {
                            src: _vm.getImage(_vm.fireImageRelativeY, 6.25)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "blackIcon leveIcon-two",
                          attrs: {
                            src: _vm.getImage(_vm.fireImageRelativeY, 31.25)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "blackIcon leveIcon-three",
                          attrs: {
                            src: _vm.getImage(_vm.fireImageRelativeY, 62.5)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "blackIcon leveIcon-four",
                          attrs: {
                            src: _vm.getImage(_vm.fireImageRelativeY, 93.75)
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        ref: "fireImage",
                        staticClass: "fireImage",
                        style: { top: _vm.progressWidth },
                        attrs: {
                          src: require("@/assets/images/yuanyuanCH.png"),
                          alt: ""
                        }
                      })
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "toSwitch" }, [
          _c("div", { staticClass: "tabs" }, [
            _c(
              "div",
              {
                staticClass: "tabs",
                class: { activeTab: _vm.activeName == "one" },
                on: {
                  click: function($event) {
                    return _vm.tabChange("one", _vm.subIdOne)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("9000006")))]),
                _vm._v(" "),
                _c("div", { staticClass: "borderBottom" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tabs",
                class: { activeTab: _vm.activeName == "two" },
                on: {
                  click: function($event) {
                    return _vm.tabChange("two", _vm.subIdTwo)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("9000007")))]),
                _vm._v(" "),
                _c("div", { staticClass: "borderBottom" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tabs",
                class: { activeTab: _vm.activeName == "three" },
                on: {
                  click: function($event) {
                    return _vm.tabChange("three", _vm.subIdThree)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("9000008")))]),
                _vm._v(" "),
                _c("div", { staticClass: "borderBottom" })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tables" }, [
            _vm.activeName == "one"
              ? _c("div", { staticClass: "tables-one" }, [
                  _c("div", { staticClass: "tablesTitle" }, [
                    _c("div", { staticClass: "tablesTitle-test1" }, [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.$t("10000006")) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesTitle-test2" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("10000003")) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tablesPic" }, [
                    _c("div", { staticClass: "tablesPic-test1" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("9000011")) +
                          "\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            (USDT)\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesPic-test2" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.moneyPond) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rankList" }, [
                    _c("div", { staticClass: "rankList-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("9000029")))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rankList-pic" }, [
                      _vm.subMsgList1.length > 0
                        ? _c("div", { staticClass: "rankListPicMain" }, [
                            _vm.subMsgList1 && _vm.subMsgList1.length >= 1
                              ? _c("div", { staticClass: "rankOne" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList1[0].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subMsgList1 && _vm.subMsgList1.length >= 2
                              ? _c("div", { staticClass: "rankTwo" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList1[1].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subMsgList1 && _vm.subMsgList1.length >= 3
                              ? _c("div", { staticClass: "rankThree" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList1[2].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isDirection
                              ? _c("img", {
                                  attrs: {
                                    src: require("../assets/images/rankBg.png")
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../assets/images/rankBgFa.png")
                                  }
                                }),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyOne" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList1[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList1[0].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyTwo" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList1[1]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList1[1].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyThree" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList1[2]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList1[2].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subMsgList1.length !== 0,
                            expression: "subMsgList1.length !== 0"
                          }
                        ],
                        staticClass: "rankList-list"
                      },
                      [
                        _c("div", { staticClass: "rankList-list-titleBg" }, [
                          _c("div", [
                            _c("span", { staticClass: "titleBg1" }, [
                              _vm._v(_vm._s(_vm.$t("300084")))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "titleBg3" }, [
                              _vm._v(_vm._s(_vm.$t("9000014")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "titleBg4" }, [
                              _vm._v(_vm._s(_vm.$t("9000013")))
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "rankScrollbar",
                        staticStyle: {
                          "max-height": "640px",
                          "overflow-y": "auto"
                        }
                      },
                      _vm._l(_vm.subMsgList1, function(item) {
                        return _c(
                          "div",
                          { key: item.index, staticClass: "rankList-listMain" },
                          [
                            _c("div", { staticClass: "listMainIcon" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "listMainIcon-img",
                                  style: {
                                    "background-image": _vm.getBackgroundImage(
                                      item.ranked
                                    )
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(item.ranked))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest1" }, [
                              _c("span", [_vm._v(_vm._s(item.userId))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest2" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.tradeProfit
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  ) + " USDT"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest3" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.rewardEstimate
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  ) + " USDT"
                                )
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subMsgList1.length === 0,
                            expression: "subMsgList1.length === 0"
                          }
                        ]
                      },
                      [
                        _c(
                          "van-empty",
                          {
                            staticClass: "custom-image",
                            attrs: { description: _vm.$t("300108") }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "icon",
                                attrs: { slot: "image", "aria-hidden": "true" },
                                slot: "image"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-zanwujilu" }
                                })
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "awardRule" }, [
                    _c("div", { staticClass: "awardRule-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("9000015")))])
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.subRulerMsg1) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "activityRule" }, [
                    _c("div", { staticClass: "activityRule-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300140")))])
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.mainRulerMsg) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeName == "two"
              ? _c("div", { staticClass: "tables-two" }, [
                  _c("div", { staticClass: "tablesTitle" }, [
                    _c("div", { staticClass: "tablesTitle-test1" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("9000022", { moneyPond: this.subNumTwo })
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesTitle-test2" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("9000028")) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tablesPic" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/anniversary/yuanMoney.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesPic-test1" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("9000011")) +
                          "\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            (USDT)\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesPic-test2" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.subNumTwo) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rankList" }, [
                    _c("div", { staticClass: "rankList-title" }, [
                      _c("span", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("9000018")) +
                            "\n                            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rankList-pic" }, [
                      _vm.subMsgList2.length > 0
                        ? _c("div", { staticClass: "rankListPicMain" }, [
                            _vm.subMsgList2 && _vm.subMsgList2.length >= 1
                              ? _c("div", { staticClass: "rankOne" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList2[0].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subMsgList2 && _vm.subMsgList2.length >= 2
                              ? _c("div", { staticClass: "rankTwo" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList2[1].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subMsgList2 && _vm.subMsgList2.length >= 3
                              ? _c("div", { staticClass: "rankThree" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList2[2].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isDirection
                              ? _c("img", {
                                  attrs: {
                                    src: require("../assets/images/rankBg.png")
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../assets/images/rankBgFa.png")
                                  }
                                }),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyOne" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList2[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList2[0].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyTwo" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList2[1]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList2[1].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyThree" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList2[2]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList2[2].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subMsgList2.length !== 0,
                            expression: "subMsgList2.length !== 0"
                          }
                        ],
                        staticClass: "rankList-list"
                      },
                      [
                        _c("div", { staticClass: "rankList-list-titleBg" }, [
                          _c("div", [
                            _c("span", { staticClass: "titleBg1" }, [
                              _vm._v(_vm._s(_vm.$t("300084")))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "titleBg3" }, [
                              _vm._v(_vm._s(_vm.$t("9000024")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "titleBg4" }, [
                              _vm._v(_vm._s(_vm.$t("9000013")))
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rankScrollbar" },
                      _vm._l(_vm.subMsgList2, function(item) {
                        return _c(
                          "div",
                          { key: item.index, staticClass: "rankList-listMain" },
                          [
                            _c("div", { staticClass: "listMainIcon" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "listMainIcon-img",
                                  style: {
                                    "background-image": _vm.getBackgroundImage(
                                      item.ranked
                                    )
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(item.ranked))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest1" }, [
                              _c("span", [_vm._v(_vm._s(item.userId))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest2" }, [
                              _c("span", [
                                _vm._v(_vm._s(item.tradeProfit) + " %")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest3" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.rewardEstimate
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  ) + " USDT"
                                )
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subMsgList2.length === 0,
                            expression: "subMsgList2.length === 0"
                          }
                        ]
                      },
                      [
                        _c(
                          "van-empty",
                          {
                            staticClass: "custom-image",
                            attrs: { description: _vm.$t("300108") }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "icon",
                                attrs: { slot: "image", "aria-hidden": "true" },
                                slot: "image"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-zanwujilu" }
                                })
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "awardRule" }, [
                    _c("div", { staticClass: "awardRule-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("9000015")))])
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.subRulerMsg2) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "activityRule" }, [
                    _c("div", { staticClass: "activityRule-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300140")))])
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.mainRulerMsg) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeName == "three"
              ? _c("div", { staticClass: "tables-three" }, [
                  _c("div", { staticClass: "tablesTitle" }, [
                    _c("div", { staticClass: "tablesTitle-test1" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("9000023", { moneyPond: this.subNumThree })
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesTitle-test2" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("9000027")) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tablesPic" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/anniversary/yuanMoney.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesPic-test1" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("9000011")) +
                          "\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            (USDT)\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tablesPic-test2" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.subNumThree) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rankList" }, [
                    _c("div", { staticClass: "rankList-title" }, [
                      _c("span", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("9000020")) +
                            "\n                            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rankList-pic" }, [
                      _vm.subMsgList3.length > 0
                        ? _c("div", { staticClass: "rankListPicMain" }, [
                            _vm.subMsgList3 && _vm.subMsgList3.length >= 1
                              ? _c("div", { staticClass: "rankOne" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList3[0].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subMsgList3 && _vm.subMsgList3.length >= 2
                              ? _c("div", { staticClass: "rankTwo" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList3[1].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subMsgList3 && _vm.subMsgList3.length >= 3
                              ? _c("div", { staticClass: "rankThree" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.subMsgList3[2].userId))
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isDirection
                              ? _c("img", {
                                  attrs: {
                                    src: require("../assets/images/rankBg.png")
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../assets/images/rankBgFa.png")
                                  }
                                }),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyOne" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList3[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList3[0].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyTwo" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList3[1]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList3[1].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "moneyThree" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("9000013")) + "(USDT)")
                              ]),
                              _vm._v(" "),
                              _vm.subMsgList3[2]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.subMsgList3[2].rewardEstimate
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subMsgList3.length !== 0,
                            expression: "subMsgList3.length !== 0"
                          }
                        ],
                        staticClass: "rankList-list"
                      },
                      [
                        _c("div", { staticClass: "rankList-list-titleBg" }, [
                          _c("div", [
                            _c("span", { staticClass: "titleBg1" }, [
                              _vm._v(_vm._s(_vm.$t("300084")))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "titleBg3" }, [
                              _vm._v(_vm._s(_vm.$t("9000025")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "titleBg4" }, [
                              _vm._v(_vm._s(_vm.$t("9000013")))
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rankScrollbar" },
                      _vm._l(_vm.subMsgList3, function(item) {
                        return _c(
                          "div",
                          { key: item.index, staticClass: "rankList-listMain" },
                          [
                            _c("div", { staticClass: "listMainIcon" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "listMainIcon-img",
                                  style: {
                                    "background-image": _vm.getBackgroundImage(
                                      item.ranked
                                    )
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(item.ranked))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest1" }, [
                              _c("span", [_vm._v(_vm._s(item.userId))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest2" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.tradeProfit
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  ) + " USDT"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "listMainTest3" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.rewardEstimate
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  ) + " USDT"
                                )
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subMsgList3.length === 0,
                            expression: "subMsgList3.length === 0"
                          }
                        ]
                      },
                      [
                        _c(
                          "van-empty",
                          {
                            staticClass: "custom-image",
                            attrs: { description: _vm.$t("300108") }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "icon",
                                attrs: { slot: "image", "aria-hidden": "true" },
                                slot: "image"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-zanwujilu" }
                                })
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "awardRule" }, [
                    _c("div", { staticClass: "awardRule-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("9000015")))])
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.subRulerMsg3) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "activityRule" }, [
                    _c("div", { staticClass: "activityRule-title" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300140")))])
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.mainRulerMsg) }
                    })
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.buySuccess
          ? _c(
              "div",
              { staticClass: "purchase-toast" },
              [
                _c("lottie", {
                  staticClass: "lottie",
                  attrs: { options: _vm.defaultOptions }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("300355")))
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.buySuccessShare
          ? _c("div", { staticClass: "purchase-toast" }, [
              _c("p", { staticClass: "boldShare" }, [
                _vm._v(_vm._s(_vm.$t("300027")))
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "proMain" }, [
      _c("div", { staticClass: "proMain-item" }, [
        _c("div", { staticClass: "proMain-item-money" }, [
          _vm._v(
            "\n                                2,500 USDT\n                            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "proMain-item-icon" }, [
          _c("div", { staticClass: "proMainNums" }, [_vm._v("＞100")]),
          _vm._v(" "),
          _c("img", {
            staticClass: "chGuys",
            attrs: { src: require("../assets/images/chGuys.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "proMain-item top1" }, [
        _c("div", { staticClass: "proMain-item-money" }, [
          _vm._v(
            "\n                                5,000 USDT\n                            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "proMain-item-icon" }, [
          _c("div", { staticClass: "proMainNums" }, [_vm._v("＞500")]),
          _vm._v(" "),
          _c("img", {
            staticClass: "chGuys",
            attrs: { src: require("../assets/images/chGuys.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "proMain-item top2" }, [
        _c("div", { staticClass: "proMain-item-money" }, [
          _vm._v(
            "\n                                7,500 USDT\n                            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "proMain-item-icon" }, [
          _c("div", { staticClass: "proMainNums" }, [_vm._v("＞1000")]),
          _vm._v(" "),
          _c("img", {
            staticClass: "chGuys",
            attrs: { src: require("../assets/images/chGuys.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "proMain-item top3" }, [
        _c("div", { staticClass: "proMain-item-money" }, [
          _vm._v(
            "\n                                10,000 USDT\n                            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "proMain-item-icon" }, [
          _c("div", { staticClass: "proMainNums" }, [_vm._v("＞1500")]),
          _vm._v(" "),
          _c("img", {
            staticClass: "chGuys",
            attrs: { src: require("../assets/images/chGuys.png") }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", { staticClass: "titleBg2" }, [_vm._v("UID")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", { staticClass: "titleBg2" }, [_vm._v("UID")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", { staticClass: "titleBg2" }, [_vm._v("UID")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95b026a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95b026a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/anniversaryActivity.vue
// module id = 0jS1
// module chunks = 0